import axios from "axios";

const token = localStorage.getItem("wow-delivery-kw-merchant-token");

const GET = async (endpoint) => {
  const response = await axios.get(endpoint, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export default GET;
